
define(
	'Tavano.HubspotPDP.HubspotPDPExt'
	, [
		'Tavano.HubspotPDP.HubspotPDPExt.View'
		, 'Utils'
		, 'underscore'
	]
	, function (
		HubspotPDPExtView
		, Utils
		, _
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var pagetypeComp = container.getComponent('PageType')
					, layoutComp = container.getComponent('Layout')
					, envComp = container.getComponent('Environment')
					, plpComp = container.getComponent('PLP');

				if (envComp.getConfig('TTHubspotPdp.enable')) {
					layoutComp.addToViewContextDefinition('ProductDetails.Full.View', 'hasHubspotLink', 'boolean', function (ctx) {
						return ctx.model.item.custitem_tt_sca_hubspot_url ? true : false;
					})

					layoutComp.addToViewContextDefinition('ProductDetails.QuickView.View', 'hasHubspotLink', 'boolean', function (ctx) {
						return ctx.model.item.custitem_tt_sca_hubspot_url ? true : false;
					})

					layoutComp.addToViewContextDefinition('Cart.QuickAddToCart.View', 'hasHubspotLink', 'boolean', function (ctx) {
						var item = _.findWhere(plpComp.getItemsInfo(), { internalid: ctx.itemId });

						return item.custitem_tt_sca_hubspot_url ? true : false;
					})

					layoutComp.registerView('HubspotPDP', function () {
						return new HubspotPDPExtView({
							container: container
						});
					})
				}

			}
		};
	});
